import React from 'react';
import ChatList from './ChatList';
import RequestList from './RequestList';
import LeftSideHeader from './LeftSideHeader';

import { LeftSideCommonProps } from './ChatList/types';

import { CustomizedButton } from '@components/Customized';

import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';

import { AddCircle } from '@material-ui/icons';

const LeftSide = ({
  route,
  matches,
  rfqIdFromParams,
  selectedChatRoomId,
  onChangePath,
  onChangeVisible
}: LeftSideCommonProps) => {
  return (
    <React.Fragment>
      <LeftSideHeader
        label={() => {
          if (route === 'chat') return '채팅';
          return '견적비교';
        }}
      >
        {route === 'dashboard' && (
          <CustomizedButton
            logId={Enum_Action_Button_Enum.Button_New_Request}
            classes={{ label: 'label' }}
            variant="text"
            endIcon={<AddCircle />}
            onClick={() => onChangePath('/request')}
          >
            <i className="request-gtm-startMakeRFQ-btn">새 견적 요청하기</i>
          </CustomizedButton>
        )}
      </LeftSideHeader>

      {route === 'chat' && (
        <ChatList
          matches={matches}
          route={route}
          rfqIdFromParams={rfqIdFromParams}
          selectedChatRoomId={selectedChatRoomId}
          onChangePath={onChangePath}
          onChangeVisible={onChangeVisible}
        />
      )}

      {route === 'dashboard' && (
        <RequestList
          route={route}
          matches={matches}
          rfqIdFromParams={rfqIdFromParams}
          selectedChatRoomId={selectedChatRoomId}
          onChangePath={onChangePath}
          onChangeVisible={onChangeVisible}
        />
      )}
    </React.Fragment>
  );
};

export default LeftSide;
